import React, { type JSX } from 'react';
import { makeObservable, observable, runInAction } from 'mobx';
import { observer } from 'mobx-react';
import Quill from 'quill';

export type SnapshotEditorProps = {
  name: string;
  content: string;
  createdAt: Date;
  createdByUser: boolean;
};

@observer
export default class SnapshotEditor extends React.Component<SnapshotEditorProps> {
  private _editorContainerRef: React.RefObject<HTMLDivElement> = React.createRef();
  private _quillInstance: Quill | null = null;
  @observable private _editorHeaderHeight = 41;

  constructor(props: SnapshotEditorProps){
    super(props);
    makeObservable(this);
  }

  componentDidMount(): void {
    window.addEventListener('resize', this._onWindowResize);
    
    // Initialize Quill in read-only mode
    if (this._editorContainerRef.current) {
      this._quillInstance = new Quill(this._editorContainerRef.current, {
        theme: 'snow',
        readOnly: true,
        modules: {
          history: false
        }
      });

      // Set content
      if (this.props.content) {
        try {
          const delta = JSON.parse(this.props.content);
          this._quillInstance.setContents(delta);
        } catch (e) {
          // Fallback to plain text if not valid JSON
          this._quillInstance.setText(this.props.content || '');
        }
      }
    }
  }

  componentWillUnmount(): void {
    window.removeEventListener('resize', this._onWindowResize);
    if (this._quillInstance) {
      this._quillInstance = null;
    }
  }

  private _onWindowResize = () => {
    const header = document.getElementsByClassName('ql-toolbar')[0];
    runInAction(() => {
      this._editorHeaderHeight = header?.getBoundingClientRect()?.height || 41;
    });
  }

  render(): JSX.Element{
    return (
      <div className="snapshot-editor-wrapper">
        <style>
          {`#snow-container .ql-container {  height: calc(100vh - ${this._editorHeaderHeight}px) !important; height: calc(var(--vh, 1vh) * 100 - ${this._editorHeaderHeight}px)!important; }`}
        </style>
        <div id="snow-container">
          <div ref={this._editorContainerRef} />
        </div>
      </div>
    );
  }
}